import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkRestoreAddress, IClientDetailsStore, IClientDetailsActions } from '../types';

const onRestoreAddress: IThunkRestoreAddress = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;

    await api.clientDetails.restoreAddress(payload);

    const addresses = localState.addresses.map(item =>
      item.id !== Number(payload.id) ? item : { ...item, isArchived: false },
    );

    setClientDetails({ addresses });
  },
);

export default onRestoreAddress;
